'use client';

import { useEffect, useRef } from 'react';
import { PENDING_SAVE_TRIP_KEY, type PendingSaveTrip } from '~/constants/savedTrips';
import { useRouter } from '~/i18n/navigation';
import { api } from '~/libs/api';

export const DeferredSaveTrip = ({ tripId }: { tripId: string }) => {
  const router = useRouter();
  const utils = api.useUtils();
  const { mutateAsync: saveTrip } = api.account.saveTrip.useMutation();

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    const raw = globalThis.sessionStorage?.getItem(PENDING_SAVE_TRIP_KEY);
    globalThis.sessionStorage?.removeItem(PENDING_SAVE_TRIP_KEY);

    let pending: PendingSaveTrip = {};
    try {
      pending = raw ? (JSON.parse(raw) as PendingSaveTrip) : {};
    } catch {
      // Malformed payload: fall back to a fetch-backed save with no carried data.
    }

    const { tripId: pendingTripId, ...carried } = pending;
    const carriedData = pendingTripId === tripId ? carried : {};

    saveTrip({ tripId, notify: true, ...carriedData })
      .catch(() => {
        // Best-effort: a failed deferred save must not block the account page.
      })
      .finally(() => {
        void utils.account.isTripSaved.invalidate({ tripId });
        void utils.account.savedTrips.invalidate();
        router.replace('/account');
      });
  }, [tripId, router, saveTrip, utils]);

  return null;
};
